import React from "react";
import { ModalButton } from "./ModalButton";
import { MailchimpDemoForm } from "./MailchimpDemoForm";
import { MailchimpTrialForm } from "./MailchimpTrialForm";
import { useTranslation } from "react-i18next";

// One button for both demo and trial requests. The modal switches between the
// two forms; only one is rendered at a time since they share Mailchimp element ids.
export function DemoTrialModalButton(props) {
    const { t } = useTranslation();
    const id = React.useId();

    const [form, setForm] = React.useState("demo");

    const tabs = [
        { key: "demo", label: t("cta-demo-button-label") },
        { key: "trial", label: t("cta-trial-button-label") },
    ];

    return (
        <ModalButton
            label={t("cta-demo-trial-button-label")}
            className={`!bg-[#242D29] hover:!bg-[#313D38] !text-base whitespace-nowrap ${
                props.className ? props.className : ""
            }`}
        >
            <div
                role="tablist"
                className="flex gap-4 mx-10 mt-10 md:mx-16"
            >
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        id={`${id}-${tab.key}-tab`}
                        aria-selected={form === tab.key}
                        aria-controls={`${id}-panel`}
                        className={`font-roboto text-base font-semibold px-10 py-4 rounded-full border-none cursor-pointer ${
                            form === tab.key
                                ? "bg-pine text-white"
                                : "bg-transparent text-pine hover:bg-gray"
                        }`}
                        onClick={() => setForm(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div
                role="tabpanel"
                id={`${id}-panel`}
                aria-labelledby={`${id}-${form}-tab`}
            >
                {form === "demo" ? (
                    <MailchimpDemoForm className="styled-markdown text-black flex flex-col mx-10 mt-2 mb-10 md:mx-16" />
                ) : (
                    <MailchimpTrialForm className="styled-markdown text-black flex flex-col mx-10 mt-2 mb-10 md:mx-16" />
                )}
            </div>
        </ModalButton>
    );
}
